export default __webpack_public_path__ + "static/media/article-preview-thumbnail.6681922d.png";